import { useState } from 'react';

const useHandleModal = (callback) => {
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const openModal = (data = null) => {
    setIsModal(true);
    setDataModal(data);
  };

  const closeModal = () => {
    setIsModal(false);
    setDataModal(null);
  };

  const submitModal = () => {
    closeModal();
    callback();
  };

  return {
    isModal,
    dataModal,
    openModal,
    closeModal,
    submitModal
  };
};
export default useHandleModal;
